import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Billing from "@/pages/Billing";
import Reviews from "@/pages/Reviews";
import ReviewForm from "@/pages/ReviewForm";
import Admin from "@/pages/Admin";
import AuditLog from "@/pages/AuditLog";
import Intelligence from "@/pages/Intelligence";
import Documents from "@/pages/Documents";
import Help from "@/pages/Help";
import Branches from "@/pages/Branches";
import Ledger from "@/pages/Ledger";
import BulkImport from "@/pages/BulkImport";
import Settings from "@/pages/Settings";
import DeletionRequests from "@/pages/DeletionRequests";
import AuthCallback from "@/pages/AuthCallback";
import PendingApproval from "@/pages/PendingApproval";
import ForcePasswordChange from "@/components/ForcePasswordChange";
import { Toaster } from "@/components/ui/sonner";

/**
 * Detect Emergent OAuth callback (`#session_id=`) synchronously during render
 * — it must run BEFORE ProtectedRoute / Routes so the cookie can be set.
 */
function App() {
  const hash = (typeof window !== "undefined" && window.location.hash) || "";
  const isOAuthCallback = hash.includes("session_id=");
  return (
    <AuthProvider>
      <BrowserRouter>
        {isOAuthCallback ? (
          <AuthCallback />
        ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pending-approval" element={<PendingApproval />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/campaigns/:id" element={<CampaignDetail />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/reviews/new" element={<ReviewForm />} />
            <Route path="/reviews/:id" element={<ReviewForm />} />
            <Route path="/intelligence" element={<Intelligence />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/help" element={<Help />} />
            <Route path="/branches" element={<ProtectedRoute roles={["crm_manager", "branch_manager"]}><Branches /></ProtectedRoute>} />
            <Route path="/ledger" element={<Ledger />} />
            <Route
              path="/bulk-import"
              element={<ProtectedRoute roles={["crm_manager", "accounts"]}><BulkImport /></ProtectedRoute>}
            />
            <Route
              path="/settings"
              element={<ProtectedRoute roles={["crm_manager"]}><Settings /></ProtectedRoute>}
            />
            <Route
              path="/deletion-requests"
              element={<ProtectedRoute roles={["crm_manager", "branch_manager"]}><DeletionRequests /></ProtectedRoute>}
            />
            <Route
              path="/admin"
              element={<ProtectedRoute roles={["crm_manager"]}><Admin /></ProtectedRoute>}
            />
            <Route
              path="/audit"
              element={<ProtectedRoute roles={["crm_manager"]}><AuditLog /></ProtectedRoute>}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
        )}
      </BrowserRouter>
      <ForcePasswordChange />
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
